import React, { useState } from 'react';

import GenericToast from '@/components/atoms/generic-toast/genericToast';
import Loader from '@/components/atoms/loader/loader';
import PredictiveSelect from '@/components/atoms/prefictive-select/predictiveSelect';
import { IServiceBranchProps } from '@/interfaces/qanty';
import { getShiftService } from '@/services/qanty-service';
import './shiftServiceBranch.scss';

const MemoShiftServiceBranch = ({
  handleSubmit,
  register,
  setValue,
  errors,
  getValues,
  listBranch,
  isLoadingSelectBranch,
  setListInfoService,
}: IServiceBranchProps) => {
  const [listService, setListService] = useState([]);
  const [isLoadingSelectService, setIsLoadingSelectService] = useState(false);
  const [openToast, setOpenToast] = useState<any>(false);
  const [showDefaultValue, setShowDefaultValue] = useState(false);
  const onChangeBranch = () => {
    const selectedBranchId = getValues('sede');
    setListService([]);
    setShowDefaultValue(true);
    getListService(selectedBranchId);
  };

  const toastMessageError = (message: string) => {
    return setOpenToast(
      <GenericToast
        message={message}
        position="up-right-small"
        setActiveToast={setOpenToast}
        size="small"
      />,
    );
  };

  const getListService = async (branchId: string) => {
    if (!branchId) return;
    setIsLoadingSelectService(true);
    try {
      const response = await getShiftService({
        branchId,
      });
      if (response.data.status !== 200) {
        toastMessageError(response.data.userMessage);
        return;
      }
      const data = response.data.data?.lines
        .map((item) => ({
          value: item.id,
          name: item.name,
          ...item,
        }))
        .sort((a, b) => a.name.localeCompare(b.name));
      setListService(data);
      setListInfoService(data);
    } catch (error) {
      console.error(error);
      const typedError = error as Error;
      toastMessageError(typedError?.message || 'Error al obtener los servicios');
      setTimeout(() => {
        window.location.reload();
      }, 2000);
    } finally {
      setIsLoadingSelectService(false);
    }
  };

  return (
    <form onSubmit={handleSubmit} className="m-shift-service-branch">
      {openToast && <>{openToast}</>}
      <div className="m-shift-service-branch__input">
        <PredictiveSelect
          label="Sede"
          name="sede"
          id="m-request-form__sede"
          register={register}
          options={
            listBranch.length
              ? listBranch
              : [
                  {
                    name: 'Selecciona una sede',
                    value: '',
                  },
                ]
          }
          setValue={setValue}
          square
          validationRules={{
            required: {
              value: true,
              message: 'Campo requerido',
            },
          }}
          error={errors.sede}
          required
          onChange={() => onChangeBranch()}
          loader={isLoadingSelectBranch}
          disabled={isLoadingSelectBranch}
          placeholder="Selecciona una sede"
        />
      </div>
      {isLoadingSelectService ? (
        <div className="m-shift-service-branch__loader">
          <Loader size="medium" />
        </div>
      ) : (
        <div className="m-shift-service-branch__input">
          <PredictiveSelect
            label="Servicio"
            name="service"
            id="m-request-form__service"
            register={register}
            options={
              listService.length
                ? listService
                : [
                    {
                      name: 'Selecciona un servicio',
                      value: '',
                    },
                  ]
            }
            setValue={setValue}
            square
            validationRules={{
              required: {
                value: true,
                message: 'Campo requerido',
              },
            }}
            defaultValue={{
              name: 'Selecciona un servicio',
              value: '',
            }}
            error={errors.service}
            required
            loader={isLoadingSelectService}
            disabled={isLoadingSelectService}
            isDefaultValue={showDefaultValue}
            placeholder="Selecciona un servicio"
          />
        </div>
      )}
    </form>
  );
};

const ShiftServiceBranch = React.memo(MemoShiftServiceBranch);
export default ShiftServiceBranch;
